import {AsYouType, CountryCode, parsePhoneNumberFromString} from 'libphonenumber-js';

/**
 * Formats a phone number based on the country code.
 * @param {string} phoneNumber - The phone number to format.
 * @param {string} countryCode - The country code to format the phone number with.
 * @returns {string} - The formatted phone number.
 */
export function formatPhoneNumber(phoneNumber: string, countryCode: CountryCode): string {
  try {
    const phone = parsePhoneNumberFromString(phoneNumber, countryCode);
    if (phone && phone.isValid()) {
      return phone.formatInternational(); // Formats to international standard e.g., "+1 202-555-0123"
    } else {
      // Fallback formatting if phone number is not valid
      return new AsYouType(countryCode).input(phoneNumber);
    }
  } catch (error) {
    console.error('error in format phone number', error);
    return phoneNumber;
  }
}
